// privacy-policy.js

import React from "react";
import "./privacy-policy.scss";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: February 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to <strong>Zullu AI</strong>. We respect your privacy and
            are committed to protecting your personal data. This Privacy Policy
            explains how we collect, use, and safeguard your information when
            you use our AI-powered platform.
          </p>
        </section>

        <section>
          <h2>2. Services We Provide</h2>
          <p>Zullu AI offers the following AI-based services:</p>
          <ul>
            <li>Text to Image Generation</li>
            <li>Text to Video Generation</li>
            <li>Image to Video Conversion</li>
            <li>AI Story Writing</li>
            <li>Google Login & Mobile OTP Authentication</li>
          </ul>
        </section>

        <section>
          <h2>3. Information We Collect</h2>

          <h3>a) Account Information</h3>
          <ul>
            <li>Name and email (when signing in via Google)</li>
            <li>Mobile number (when signing in via OTP)</li>
          </ul>

          <h3>b) Usage Data</h3>
          <ul>
            <li>Prompts you submit (text, image, video requests)</li>
            <li>Generated AI outputs</li>
            <li>Device and browser information</li>
            <li>IP address and general location data</li>
          </ul>
        </section>

        <section>
          <h2>4. How We Use Your Information</h2>
          <ul>
            <li>To provide and improve AI services</li>
            <li>To authenticate users securely</li>
            <li>To enhance performance and user experience</li>
            <li>To prevent abuse, fraud, or illegal activity</li>
            <li>To communicate important updates</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Storage & Security</h2>
          <p>
            We implement industry-standard security measures to protect your
            personal information. While we strive to use commercially acceptable
            means to protect your data, no method of transmission over the
            Internet is 100% secure.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Services</h2>
          <p>
            We may use trusted third-party providers for authentication,
            analytics, AI processing, and hosting services. These providers only
            access information necessary to perform their functions and are
            obligated to protect your data.
          </p>
        </section>

        <section>
          <h2>7. Cookies & Tracking</h2>
          <p>
            Zullu AI may use cookies and similar technologies to enhance your
            experience, remember preferences, and analyze platform usage.
          </p>
        </section>

        <section>
          <h2>8. User Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account</li>
            <li>Withdraw consent where applicable</li>
          </ul>
        </section>

        <section>
          <h2>9. Children's Privacy</h2>
          <p>
            Zullu AI is not intended for individuals under the age of 13. We do
            not knowingly collect personal data from children.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically. Any changes will be
            posted on this page with an updated revision date.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us
            at:
          </p>
          <p className="contact-email">info@zulluai.com</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
